import gql from 'graphql-tag';

export const UPDATE_ACTION_TAKEN_MUTATION = gql`
  mutation updateActionTaken($input: UpdateActionTakenInput!) {
    updateActionTaken(input: $input) {
      success
    }
  }
`;
